import { graphql } from "@/graphql/generated/gql";

export const createMunicipalPropertyMutationDocument = graphql(/* GraphQL */ `
  mutation CreateMunicipalProperty($input: CreateMunicipalPropertyInput!) {
    createMunicipalProperty(input: $input) {
      id
      name
      type
      municipalityList {
        id
        name
      }
    }
  }
`);
